import { render, staticRenderFns } from "./UldkParcels.vue?vue&type=template&id=6803e84a&scoped=true"
import script from "./UldkParcels.vue?vue&type=script&lang=js"
export * from "./UldkParcels.vue?vue&type=script&lang=js"
import style0 from "./UldkParcels.vue?vue&type=style&index=0&id=6803e84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6803e84a",
  null
  
)

export default component.exports